<template>
  <NuxtLink v-slot="{ route, href, isActive }" :to="to" custom>
    <a
      :href="href"
      :class="['dashboard-sidebar-link-ui', isActive && 'dashboard-sidebar-link-ui--active']"
      @click.prevent="handleClick(route)"
    >
      <slot />
    </a>
  </NuxtLink>
</template>

<script setup lang="ts">
  // Types
  import type { PropType } from 'vue';
  import type { RouteLocationNormalizedLoaded, RouteLocationRaw } from 'vue-router';
  import type { EAnalyticsEvent } from '~/misc/services/analytics/types';

  // Utils
  import { eventBus } from '~/misc/utils/event-bus';

  const props = defineProps({
    to: {
      type: [String, Object] as PropType<RouteLocationRaw>,
      required: true,
    },
    analyticsEvent: {
      type: String as PropType<EAnalyticsEvent | undefined>,
      default: undefined,
    },
  });

  const emit = defineEmits<{
    (e: 'navigate', route: RouteLocationNormalizedLoaded): void;
  }>();

  const handleClick = (route: RouteLocationNormalizedLoaded) => {
    if (props.analyticsEvent) {
      eventBus.emit(props.analyticsEvent);
    }

    emit('navigate', route);
  };
</script>
